/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled from 'styled-components';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledLogo = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  z-index: 1;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledLogo/index.js